import React from 'react';
import { CTAButton, CHECKOUT_URL, PRICE, PRICE_SHORT, Section } from './Shared';
import { DnaHelix, TreeOfLife } from './BioDecor';
export function EmotionalClose() {
  return <Section className="max-w-4xl" data-id="element-61" data-mp="vm36ltn1tpby">
      <div className="relative overflow-hidden rounded-3xl border border-brand-greenSoft/40 bg-brand-sageMist/50 p-6 text-center md:p-12" data-id="element-62" data-mp="vlbcyod0i1ob">
        <DnaHelix className="pointer-events-none absolute -left-4 -top-6 h-40 w-20 text-brand-blueSoft/30" data-id="element-63" data-mp="ql715bn1tv4f" />
        <TreeOfLife className="pointer-events-none absolute -bottom-8 -right-4 h-48 w-28 text-brand-greenSoft/25" data-id="element-64" data-mp="mjbv5tu6atkb" />
        <div className="relative" data-id="element-65" data-mp="cn8oqbsag8rk">
          <h2 className="mb-6 font-display text-3xl font-bold leading-tight text-brand-blue md:text-4xl" data-id="element-66" data-mp="coa2io0ov9cz">
            La próxima sesión puede ser diferente.
          </h2>
          <div className="mx-auto mb-10 max-w-2xl space-y-4 text-base leading-relaxed text-brand-textLight md:text-lg" data-id="element-67" data-mp="2721kqbx331k1">
            <p data-id="element-68" data-mp="223huw0fdd5me">Hay dos versiones de vos en este momento.</p>
            <p data-id="element-69" data-mp="352ixayp8mdxt">
              <strong className="text-brand-blue" data-id="element-70" data-mp="351zms31x2rtt">Una</strong> que cierra esta página y la próxima sesión sigue
              improvisando. Sigue sin identificar el conflicto biológico. Sigue sin tener rituales listos. Sigue
              cobrando lo que cobraba hace dos años.
            </p>
            <p className="font-semibold text-brand-greenMid" data-id="element-71" data-mp="302wgkfa7afk9">
              Y otra que decide que hoy es el día en que su práctica cambia para siempre.
            </p>
            <p className="font-serif text-lg italic text-brand-goldDark md:text-xl" data-id="element-72" data-mp="3nv3h7qmyl8ph">
              La pregunta no es si podés pagarlo.
              <br data-id="element-73" data-mp="3e3qsh7wgiyno" />
              La pregunta es cuántas sesiones más vas a trabajar sin un sistema que te respalde.
            </p>
          </div>

          <div className="mx-auto max-w-md rounded-2xl border-2 border-brand-gold/60 bg-white p-6 shadow-[0_10px_30px_rgba(8,32,60,.14)]" data-id="element-74" data-mp="3j0h8jv89hu93">
            <span className="relative -top-9 inline-block rounded-full bg-brand-blue px-3 py-1 text-xs font-bold text-brand-goldLight" data-id="element-75" data-mp="fcxdok80iwoi">
              ⭐ MÁS ELEGIDO
            </span>
            <h3 className="-mt-4 font-serif text-xl font-bold text-brand-blue" data-id="element-76" data-mp="ka31q1gvsia2">
              🏆 KIT MAESTRO DE BIODESCODIFICACIÓN™
            </h3>
            <p className="my-2 text-4xl font-bold text-brand-greenMid" data-id="element-77" data-mp="g76dnv8kntyq">{PRICE}</p>
            <p className="mb-5 text-sm leading-relaxed text-brand-muted" data-id="element-78" data-mp="ba7lhi8gxx36">
              3 Tomos + 5 Bonus · Más de 150 páginas. El sistema integral de protocolos, rituales, protección legal y
              seguimiento post-sesión.
            </p>
            <CTAButton href={CHECKOUT_URL} variant="gold" fullWidth className="text-sm md:text-base" data-id="element-79" data-mp="1hibyswhatah">
              🏆 → QUIERO MI KIT MAESTRO {PRICE_SHORT}
            </CTAButton>
            <p className="mt-4 text-[11px] text-brand-muted" data-id="element-80" data-mp="3opvshzinxw4r">
              🛡️ Garantía 7 días · 📥 Descarga inmediata · 🔒 Pago seguro · 💳 Mercado Pago
            </p>
          </div>
        </div>
      </div>
    </Section>;
}